import { getDataBase } from '../db';

export default class FacturaDetalleDAL {


    async GetRecDt(tcFactura){
        try {
            const db = await getDataBase();
            const tx = db.transaction('FACTURADETALLE', 'readonly');
            const store = tx.objectStore('FACTURADETALLE');
            // const laData = await store.getAll(Number(tcFactura));
            const index = store.index('Factura');
            const laData = await index.getAll(Number(tcFactura));


            //realizar un foreach para buscar los datos de la factura
            const laResultados = [];

            // Filtramos los registros que cumplen con las condiciones de Inicio y Fin
            laData.forEach(laData => {
                if (laData.SobreServicio == 0) {
                    laResultados.push(laData);
                }
            });

            await tx.done;
            return laResultados;
        } catch (error) {
          console.error('Error GetRecDt en FacturaDetalleDAL', error);
          return [];
        }
    }

    async Seek(tcFactura){
        try {
            const db = await getDataBase();
            const tx = db.transaction('FACTURADETALLE', 'readonly');
          
            const store = tx.objectStore('FACTURADETALLE');
            const index = store.index('Factura');
            const laData = await index.getAll(Number(tcFactura));

            //realizar un foreach para buscar los datos de la factura
            const laResultados = [];

            // Filtramos los registros que cumplen con las condiciones de Inicio y Fin
            laData.forEach(laData => {
                console.log('loData', laData);
                
                if (laData.SobreServicio > 0) {
                    laResultados.push(laData);
                }
            });

            await tx.done;
            return laResultados;
        } catch (error) {
          console.error('Error en el metodo Seek de FacturaDetalleDal:', error);
          throw new Error( error);
        }
    }


    // async GetFacturaDetalle(tnFactura){
    //     const db = await getDataBase();
    //     const tx = db.transaction('FACTURADETALLE', 'readonly');
      
    //     const store = tx.objectStore('FACTURADETALLE');
    //     const index = store.index('Factura');
    //     const laData = await index.getAll(Number(tnFactura));

    //     //BUSCAR POR SERVICIO Y ACTUALIAR


    //     await tx.done;
    //     return laData;

    // }

    async ActualizarItem(Factura, $Cliente, MontoPago, TipoTabla, Servicio, $DataBaseAlias){
      
   
        if (TipoTabla > -1) {
        
            //ACTIALZIAR, BUSCAR MISMA FACTURA Y MISMO SERVICIO
            const db = await getDataBase();
            const tx = db.transaction('FACTURADETALLE', 'readwrite');
          
            const store = tx.objectStore('FACTURADETALLE');
            const index = store.index('Factura');
            const laFacturaDetalles = await index.getAll(Number(Factura));
    
            //BUSCAR POR SERVICIO Y ACTUALIAR
            // laFacturaDetalles.forEach(async loFacturaDetalle => {
            for (const loFacturaDetalle of laFacturaDetalles) {
                if (loFacturaDetalle.Servicio == Servicio) {
                    loFacturaDetalle.MontoPago = MontoPago;
                    loFacturaDetalle.MontoPagado = MontoPago;
                    await store.put(loFacturaDetalle);
                }
            };
            await tx.done;
            return laFacturaDetalles;
        }else{
            const db = await getDataBase();
            const tx = db.transaction('FACTURADETALLE', 'readwrite');
          
            const store = tx.objectStore('FACTURADETALLE');
            const index = store.index('Factura');
            const laFacturaDetalles = await index.getAll(Number(Factura));
    
            //BUSCAR POR SERVICIO Y ACTUALIAR
            for (const loFacturaDetalle of laFacturaDetalles) {
                if (loFacturaDetalle.Servicio == Servicio && loFacturaDetalle.Tipo == TipoTabla) {
                    loFacturaDetalle.MontoPago = MontoPago;
                    loFacturaDetalle.MontoPagado = MontoPago;
                    await store.put(loFacturaDetalle);
                }
            };
            await tx.done;
            return laFacturaDetalles
        }
        
      

        // if (TipoTabla > -1) {
        //     $loFacturaDetalle = FacturaDetalle::on($DataBaseAlias)
        //         ->where('Factura', '=', Factura)
        //         ->where('Servicio', '=', Servicio)
        //         ->update([
        //             "MontoPago"   => MontoPago,
        //             "MontoPagado" => MontoPago
        //         ]);
        // }else {
        //     $loFacturaDetalle = FacturaDetalle::on($DataBaseAlias)
        //         ->where('Factura', '=', Factura)
        //         ->where('Servicio', '=', Servicio)
        //         ->where('Tipo', '=', TipoTabla)
        //         ->update([
        //             "MontoPago"   => MontoPago,
        //             "MontoPagado" => MontoPago
        //         ]);
        // }
        // return $loFacturaDetalle;
    }

    
    async ActualizarItem2(Factura, Servicio, MontoPago, $DataBaseAlias){
 
        const db = await getDataBase();
        const tx = db.transaction('FACTURADETALLE', 'readwrite');
        const store = tx.objectStore('FACTURADETALLE');
        const index = store.index('Factura');
        const laFacturaDetalles = await index.getAll(Number(Factura));

        for (const loFacturaDetalle of laFacturaDetalles) {
            if (loFacturaDetalle.Servicio == Servicio) {
                    loFacturaDetalle.MontoPago = MontoPago;
                    await store.put(loFacturaDetalle);
                }
        }

        await tx.done;
        
        // $loFacturaDetalle = FacturaDetalle::on($DataBaseAlias)
        //     ->where('Factura', '=', Factura)
        //     ->where('Servicio', '=', Servicio)
        //     ->update([
        //         "MontoPago"   => MontoPago
        //     ]);
    }

    async GetId_Factura(Cliente, DataBaseAlias){
        try {
            const db = await getDataBase();
            const tx = db.transaction('FACTURA', 'readwrite');
            const store = tx.objectStore('FACTURA');
            const index = store.index('Cliente');
            const laFacturas = await index.getAll(Number(Cliente));

            // Ordenar por 'Factura' en orden descendente
            laFacturas.sort((a, b) => {
                if (a.Factura > b.Factura) {
                    return -1; // b debería ir antes que a
                } else if (a.Factura < b.Factura) {
                    return 1; // a debería ir antes que b
                } else {
                    return 0; // son iguales
                }
            });

            if (laFacturas.length == 0) {
                console.error('No se encontraron facturas para el cliente:', Cliente);
                return [];
            }

            // Obtener la factura con el valor más alto
            const lnFactura = laFacturas[0].Factura;
            await tx.done;
            return lnFactura;
        } catch (error) {
            console.error('Error en GetId_Factura:', error);
            return [];
            
        }
    }




    // public function GetId_Factura($Cliente, $DataBaseAlias){
    //     $loFactura = Factura::on($DataBaseAlias)
    //         ->select('Factura')
    //         ->where('Cliente', '=', $Cliente)
    //         ->OrderBy('Factura', 'DESC')
    //         ->limit(1)
    //         ->get();

    //     $loFactura = $loFactura[0]->Factura;

    //     return $loFactura;
    // }


    //se quito DataBaseAlias y se agrego factura
    async GetDetalleFactura(Cliente, DataBaseAlias){
       
        //convetir a lectura
        const lnFactura = await this.GetId_Factura(Cliente, DataBaseAlias);

        // $loFacturaDetalle = FacturaDetalle::on($DataBaseAlias)
        //     ->join('SERVICIO', 'FACTURADETALLE.Servicio', '=', 'SERVICIO.Servicio')
        //     ->select('FACTURADETALLE.Servicio', 'SERVICIO.NombreServicio', 'FACTURADETALLE.MontoPago')
        //     ->where('FACTURADETALLE.Factura', '=', $loFactura)
        //     ->get();

        // return $loFacturaDetalle;

        try {
            const db = await getDataBase();
            const tx = db.transaction('FACTURADETALLE', 'readwrite');
            const store = tx.objectStore('FACTURADETALLE');
            const index = store.index('Factura');
            const laFacturaDetalles = await index.getAll(Number(lnFactura));
    
            await tx.done;
            return laFacturaDetalles;
        } catch (error) {
            console.error('Error en GetDetalleFactura:', error);
            return [];
            
        }




    }



     // public function GetMontos($Factura, $Sirese, $DataBaseAlias){
    //     if ($Sirese == 0) {
    //         $loFacturaDetalle = FacturaDetalle::on($DataBaseAlias)
    //             ->select((DB::raw('SUM(MontoPago) as MontoTotal')),
    //                         DB::raw('SUM(CASE WHEN (PorcentajeIva = 1) THEN MontoPago ELSE 00000 END) as MontoFiscal'))
    //             ->where('Factura', '=', $Factura)->get();
    //     }else{
    //         $loFacturaDetalle = FacturaDetalle::on($DataBaseAlias)
    //             ->select((DB::raw('SUM(MontoPago) as MontoTotal')),
    //                         DB::raw('SUM(CASE WHEN (PorcentajeIva = 1) THEN MontoPago ELSE 00000 END) as MontoFiscal'))
    //             ->where('Factura', '=', $Factura)
    //             ->where('Servicio', '<>', $Sirese)->get();
    //     }
    //     return $loFacturaDetalle;
    // }

    async GetMontos(Factura, Sirese, DataBaseAlias){
        const loReturn = [];
        if (Sirese == 0 ) {
          
                // Abrir la base de datos y comenzar una transacción de lectura
                const db = await getDataBase();
                const tx = db.transaction('FACTURADETALLE', 'readonly');
                const store = tx.objectStore('FACTURADETALLE');
                const index = store.index('Factura');
            
                // Obtener todos los detalles de la factura usando el índice 'Factura'
                const loFacturaDetalles = await index.getAll(Factura);
            
                // Inicializar los acumuladores
                let MontoTotal = 0;
                let MontoFiscal = 0;
            
                // Iterar sobre los detalles de la factura y acumular los montos
                loFacturaDetalles.forEach(loFacturaDetalle => {
                    // Acumular el total del monto pagado
                    MontoTotal += Number(loFacturaDetalle.MontoPago);
                    // Acumular el monto fiscal solo si PorcentajeIva es 1 (simulación de CASE en SQL)
                    if (loFacturaDetalle.PorcentajeIva == 1) {
                        MontoFiscal += Number(loFacturaDetalle.MontoPago);
                    }
                });
            
                // Devolver los montos como un objeto
                loReturn.push({
                    MontoTotal,
                    MontoFiscal
                });
                await tx.done;
            
        }else{
                // Abrir la base de datos y comenzar una transacción de lectura
                const db = await getDataBase();
                const tx = db.transaction('FACTURADETALLE', 'readonly');
                const store = tx.objectStore('FACTURADETALLE');
                const index = store.index('Factura');
            
                // Obtener todos los detalles de la factura que coincidan con el número de factura
                const loFacturaDetalles = await index.getAll(Factura);
            
                // Inicializar los acumuladores
                let MontoTotal = 0;
                let MontoFiscal = 0;
            
                // Filtrar por Servicio y acumular montos
                loFacturaDetalles.forEach(loFacturaDetalle => {
                    // Excluir registros cuyo Servicio sea igual a Sirese
                    if (loFacturaDetalle.Servicio != Sirese) {
                        // Acumular el total del monto pagado
                        MontoTotal = MontoTotal + Number(loFacturaDetalle.MontoPago);
            
                        // Acumular el monto fiscal solo si PorcentajeIva es 1 (simulación de CASE en SQL)
                        if (loFacturaDetalle.PorcentajeIva == 1) {
                            MontoFiscal = MontoFiscal + Number(loFacturaDetalle.MontoPago);
                        }
                    }
                });
            
                // Devolver los montos como un objeto
                loReturn.push({
                    MontoTotal,
                    MontoFiscal
                });
                await tx.done;
            
        }
        return loReturn
    }
}